module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_30.6201c1cd.png";